import { skillSelectors } from 'store/skill';
import { Spot } from 'domain/Spot';
import DomainObjectView from 'domain/DomainObjectView';
import { Map } from 'immutable';
import { AppState } from '../types';
import { employeeSelectors } from 'store/employee';

export const getSpotById = (state: AppState, id: number): Spot => {
  if (state.spotList.isLoading || state.skillList.isLoading || state.employeeList.isLoading) {
    throw Error('Spot list or dependencies are loading');
  }
  const spotView = state.spotList.spotMapById.get(id) as DomainObjectView<Spot>;
  return {
    ...spotView,
    requiredSkillSet: spotView.requiredSkillSet.map((skillId) => skillSelectors.getSkillById(state, skillId)),
    blockedEmployeeSet: (spotView.blockedEmployeeSet || []).map((employeeId) => employeeSelectors.getEmployeeById(state, employeeId)),
    rotationEmployee: spotView.rotationEmployee != null ? employeeSelectors.getEmployeeById(state, spotView.rotationEmployee) : null,
  };
};

let oldSpotMapById: Map<number, DomainObjectView<Spot>> | null = null;
let spotListForOldSpotMapById: Spot[] | null = null;
let oldEmployeeMapByIdForSpotList: AppState['employeeList']['employeeMapById'] | null = null;

export const getSpotList = (state: AppState): Spot[] => {
  if (state.spotList.isLoading || state.skillList.isLoading || state.employeeList.isLoading) {
    return [];
  }
  
  if (
    oldSpotMapById === state.spotList.spotMapById &&
    oldEmployeeMapByIdForSpotList === state.employeeList.employeeMapById &&
    spotListForOldSpotMapById !== null
  ) {
    return spotListForOldSpotMapById;
  }

  const out = state.spotList.spotMapById.keySeq().map((key) => getSpotById(state, key))
    .sortBy((spot) => spot.name).toList();

  oldSpotMapById = state.spotList.spotMapById;
  oldEmployeeMapByIdForSpotList = state.employeeList.employeeMapById;

  spotListForOldSpotMapById = out.toArray();
  return spotListForOldSpotMapById;
};

export const getActiveSpotList = (state: AppState): Spot[] => {
  return getSpotList(state).filter(spot => spot.status);
};
